import React from "react";
import { ArrowRightIcon, CheckIcon, ShieldCheckIcon } from "lucide-react";
import { bonuses, offerFacts, offerIncludes, priceCardIncludes, product } from "../data/landing";
import { BONUS_COVERS } from "../data/visuals";
import { getCheckoutUrl } from "../utils/checkout";
import { trackPixelEvent } from "../utils/metaPixel";
import { CtaButton } from "./CtaButton";
import { KitMockup } from "./KitMockup";
type OfferSectionProps = {
  cardRef: React.RefObject<HTMLDivElement>;
};
export function OfferSection({
  cardRef
}: OfferSectionProps) {
  return <section className="section offer-section" id="offer-details" data-id="element-87" data-mp="mgwjr9c9vuf2">
      <div className="shell" data-id="element-88" data-mp="rf7tzl6hc6xt">
        <div className="section-intro" data-id="element-89" data-mp="rbtuckp7abu2">
          <p className="eyebrow" data-id="element-90" data-mp="wd9d263wo69a">YOUR NEXT TEAM TRAINING STARTS HERE</p>
          <h2 data-id="element-91" data-mp="2t59jfd5n3imx">
            Your next team training.
            <br data-id="element-92" data-mp="2t6kve098nwp4" />
            <span data-id="element-93" data-mp="2t743yqd018qh">All in one kit.</span>
          </h2>
        </div>
        <div className="offer-grid" data-id="element-94" data-mp="2y5fd0yvgzf7n">
          <div className="offer-contents" data-id="element-95" data-mp="2y6gqtb3veft2">
            <p className="eyebrow" data-id="element-96" data-mp="12o1rms1ygi2r">THE COMPLETE DIGITAL KIT</p>
            <h3 data-id="element-97" data-mp="12pcyx1um07ym">{product.name}</h3>
            <p data-id="element-98" data-mp="xwa4yslx6whw">
              Ten 30-minute facilitator-led sessions for difficult customer conversations, plus five resources to help you
              prepare, practice and follow up.
            </p>

            <dl className="offer-facts" data-id="element-99" data-mp="owwr7nqrjlrd">
              {offerFacts.map(f => <div key={f.label} data-id="element-100" data-mp="1lm4cqvrdtuva">
                  <dt data-id="element-101" data-mp="1ll338vq0lgfo">{f.label}</dt>
                  <dd data-id="element-102" data-mp="1lk0ccnsozdzr">{f.value}</dd>
                </div>)}
            </dl>

            <h4 data-id="element-103" data-mp="1gl6w4nm0t8vw">The core kit</h4>
            <ul className="offer-includes" data-id="element-104" data-mp="1clfzi39tbyjg">
              {offerIncludes.map(item => <li key={item.title} data-id="element-105" data-mp="17mlfiy0403xr">
                  <CheckIcon size={18} aria-hidden="true" data-id="element-106" data-mp="17ljxg9koeh6j" />
                  <div data-id="element-107" data-mp="169gkupgqi14">
                    <strong data-id="element-108" data-mp="16sxc83dn0dk">{item.title}</strong>
                    <p data-id="element-109" data-mp="14g8rc345rrj">{item.text}</p>
                  </div>
                </li>)}
            </ul>

            <h4 data-id="element-110" data-mp="3ttzswb5v8ip9">Plus all five bonuses, included at no extra cost</h4>
            <ul className="offer-bonuses" data-id="element-111" data-mp="3tusqalixpvuq">
              {bonuses.map((bonus, i) => <li key={bonus.title} data-id="element-112" data-mp="2n6g0a1pmv4w" data-mpi={i}>
                  <img src={BONUS_COVERS[i]} alt="" width={1024} height={1024} loading="lazy" decoding="async" data-id="element-113" data-mp="3ktbehfck8gbu" />
                  <div data-id="element-114" data-mp="3oumv4vdghr7w">
                    <span data-id="element-115" data-mp="3otvaugpb7fwx">BONUS 0{i + 1}</span>
                    <strong data-id="element-116" data-mp="3owr8e3x8w2ku">{bonus.title}</strong>
                    <p data-id="element-117" data-mp="3b2gr27nkvaot">{bonus.benefit}</p>
                  </div>
                </li>)}
            </ul>
          </div>

          <div className="price-card" id="purchase-card" ref={cardRef} data-id="element-118" data-mp="3fvjcfsi7bdtx">
            <div className="price-cover" data-id="element-119" data-mp="316dh4fmhi7rb">
              <KitMockup decorative data-id="element-120" data-mp="313he4cvs4sw0" />
            </div>
            <p className="price-caption" data-id="element-121" data-mp="365ggpkjp3lrw">10 SESSIONS + 5 BONUSES</p>
            <p className="offer-price" data-id="element-122" data-mp="2s4vxin9vbnxv">
              <span data-id="element-123" data-mp="2s55s6o5uyj9w">$27</span> USD
            </p>
            <p className="payment-note" data-id="element-124" data-mp="2x3h20yw5kts4">One-time payment. No subscription.</p>
            <p className="per-session" data-id="element-125" data-mp="2x5tjzc1wv456">That’s $2.70 per ready-to-run session.</p>
            <ul className="price-includes" data-id="element-126" data-mp="2di73h0ydy2yv">
              {priceCardIncludes.map(item => <li key={item} data-id="element-127" data-mp="28kf2zijod8j2">
                  <CheckIcon size={15} aria-hidden="true" data-id="element-128" data-mp="2min3g0fx6ryz" />
                  {item}
                </li>)}
            </ul>
            <CtaButton href={getCheckoutUrl()} onClick={() => trackPixelEvent("InitiateCheckout", {
            value: Number(product.price),
            currency: product.currency,
            content_name: product.name
          })} data-id="element-129" data-mp="2ifyttqjdth0y">
              Get my training kit <ArrowRightIcon size={18} aria-hidden="true" data-id="element-130" data-mp="368fb3yvap4z7" />
            </CtaButton>
            <div className="delivery-details" data-id="element-131" data-mp="319m9p4ta94fe">
              <p data-id="element-132" data-mp="3f6r8cjqo310m">
                <ShieldCheckIcon size={17} aria-hidden="true" data-id="element-133" data-mp="3f8c3aagw8lz0" />
                10-day money-back guarantee
              </p>
            </div>
            <p className="format-note" data-id="element-134" data-mp="3a6d133ww3v3n">
              English-language PDFs.
              <br data-id="element-135" data-mp="18is0u44owe1s" />
              No physical books or editable slide decks.
            </p>
            <a className="faq-link" href="#faq" data-id="element-136" data-mp="1dgk5zzuchwnx">
              Read the format FAQs
            </a>
          </div>
        </div>
      </div>
    </section>;
}